// @flow
import isEmpty from 'lodash/isEmpty';
const tokenName = 'user';

export const tokenManager = (): Object => {
  // Токен авторизации
  let token: ?string;
  // Получение токена из мемоизированной переменной или localStorage
  const getToken = (): ?string =>
    (isEmpty(token) ? '' : token) || localStorage.getItem(tokenName) || null;

  return {
    // Получение токена
    getToken,
    // Обновление токена
    setToken: (newToken: string): void => {
      if (newToken) {
        localStorage.setItem(tokenName, newToken);
        token = newToken;
      }
    },
    clearToken: () => localStorage.removeItem(tokenName)
  };
};

const tokenWrapper = tokenManager();

export default tokenWrapper;
